var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          { attrs: { id: "new-accounting-content" } },
          [
            _vm.isLoading
              ? _c("Spinner", { attrs: { "is-loading": _vm.isLoading } })
              : _vm.serverError !== null
              ? _c("Message", {
                  attrs: {
                    message: _vm.serverError.message,
                    icon: _vm.serverError.icon,
                    "as-card": true,
                    "button-content": _vm.serverError.buttonContent || "",
                  },
                  on: { click: _vm.loadAccountableData },
                })
              : _vm.successfulAccounting !== null
              ? _c("Message", {
                  attrs: {
                    message: _vm.successfulAccounting.message,
                    icon: _vm.successfulAccounting.icon,
                    "as-card": true,
                    "button-content":
                      _vm.successfulAccounting.buttonContent || "",
                  },
                  on: { click: _vm.loadAccountableData },
                })
              : !_vm.isLoading
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "card-item mt-6 has-overflow",
                      attrs: { id: "accountance-summary" },
                    },
                    [
                      _vm.accountableRows.length === 0
                        ? _c(
                            "div",
                            { staticClass: "message-info has-text-centered" },
                            [
                              _c("i", {
                                staticClass:
                                  "fas fa-exclamation-circle is-pulled-left",
                              }),
                              _c("div", { staticClass: "message-text" }, [
                                _c("span", [
                                  _vm._v("No hay registros por contabilizar"),
                                ]),
                              ]),
                            ]
                          )
                        : _c(
                            "div",
                            [
                              _c("div", { staticClass: "columns" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "column mt-2 is-two-fifths is-flex is-flex-direction-column",
                                  },
                                  [
                                    _c("span", { staticClass: "is-flex" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "icon-item-pending is-flex is-align-items-center is-justify-content-center",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-ellipsis has-text-warning is-size-4",
                                          }),
                                        ]
                                      ),
                                      _c("span", [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              "has-text-grey has-text-weight-medium is-size-6",
                                          },
                                          [
                                            _vm._v(
                                              "Hay " +
                                                _vm._s(_vm.elementsToAccount) +
                                                " registro" +
                                                _vm._s(
                                                  _vm.elementsToAccount > 1
                                                    ? "s"
                                                    : ""
                                                ) +
                                                " por contabilizar"
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _vm._l(
                                      _vm.differenceAccountableSummary,
                                      function (item) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.name,
                                            attrs: {
                                              id: `balance-${item.name}`,
                                            },
                                          },
                                          [
                                            item.value !== 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex is-align-items-center mx-1 my-4 is-size-7",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "p-4" },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-solid fa-triangle-exclamation has-text-danger",
                                                        }),
                                                        _vm._v(
                                                          " Se detectó un descuadre en la contabilidad. Puedes dar aviso al equipo producto en el correo."
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: "mailto:g_producto_creditu@creditu.com",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              attrs: {
                                                                type: "is-text",
                                                                size: "is-small",
                                                              },
                                                            },
                                                            [_vm._v("Avisar")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mx-1 my-4 is-size-7",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-circle-check has-text-primary",
                                                    }),
                                                    _vm._v(" Sin diferencia"),
                                                  ]
                                                ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm.accountableRows.length > 0
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "is-rounded download-button",
                                                attrs: {
                                                  id: "download-excel",
                                                  size: "is-small",
                                                  type: "mr-4",
                                                  "icon-left": "download",
                                                },
                                                on: {
                                                  click: _vm.downloadExcelFile,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Descargar Excel"),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "column" },
                                  _vm._l(
                                    _vm.leftAccountableSummary,
                                    function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.name,
                                          attrs: { id: `balance-${item.name}` },
                                        },
                                        [
                                          _vm.$t(item.name.toLowerCase()) !==
                                          "Diferencia"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-item shadowless assets-box",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "has-text-primary",
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              item.name.toLowerCase()
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        id: `balance-${item.name}-value`,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatCurrency(
                                                            item.value
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.differenceAccountableSummary,
                                                    function (i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: i.name,
                                                          staticClass:
                                                            "difference-box is-size-7",
                                                          attrs: {
                                                            id: `balance-${i.name}`,
                                                          },
                                                        },
                                                        [
                                                          i.value !== 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "is-flex is-align-items-center mx-1 my-4",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "mr-1",
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa-solid fa-triangle-exclamation has-text-danger",
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                i.name.toLowerCase()
                                                                              )
                                                                            ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      attrs: {
                                                                        id: `balance-${i.name}-value`,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.formatCurrency(
                                                                            i.value
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _c(
                                  "div",
                                  { staticClass: "column" },
                                  _vm._l(
                                    _vm.rightAccountableSummary,
                                    function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.name,
                                          attrs: { id: `balance-${item.name}` },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card-item shadowless",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "has-text-primary",
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          item.name.toLowerCase()
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    id: `balance-${item.name}-value`,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        item.value
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "is-pulled-right is-button-primary",
                                  attrs: {
                                    id: "account-button",
                                    disabled:
                                      !_vm.checkUserFeature(
                                        "element.accounting.button.contabilizar"
                                      ) || _vm.isAccountButtonIsDisabled,
                                    "icon-right": "angle-right",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.isConfirmToAccountVisible = true
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("Contabilizar")])]
                              ),
                              _c("ConfirmAccountModal", {
                                attrs: {
                                  "number-of-accountable-entities":
                                    _vm.accountableEntities.length,
                                  "accounting-button-disabled":
                                    _vm.isAccountingButtonDisabled,
                                },
                                on: { account: _vm.setEntitiesAsAccounted },
                                model: {
                                  value: _vm.isConfirmToAccountVisible,
                                  callback: function ($$v) {
                                    _vm.isConfirmToAccountVisible = $$v
                                  },
                                  expression: "isConfirmToAccountVisible",
                                },
                              }),
                            ],
                            1
                          ),
                    ]
                  ),
                  _vm.pendingEntities.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "card-item has-overflow",
                          attrs: { id: "pending-accountables" },
                        },
                        [
                          _c("p", [
                            _vm._v("Existen "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.pendingEntities.length)),
                            ]),
                            _vm._v(
                              " registros que quedaron fuera del listado de movimientos a contabilizar, en espera a que se completen sus datos:"
                            ),
                          ]),
                          _c("br"),
                          _c(
                            "b-table",
                            {
                              attrs: {
                                paginated: "",
                                hoverable: "",
                                "per-page": _vm.perPage,
                                "current-page": _vm.currentPage,
                                data: _vm.pendingEntities,
                              },
                              on: {
                                "page-change": function ($event) {
                                  return _vm.$emit("update:currentPage", $event)
                                },
                              },
                            },
                            _vm._l(
                              _vm.pendingEntitiesHeaders,
                              function (column, index) {
                                return _c("b-table-column", {
                                  key: index,
                                  attrs: { label: column.title },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            _c(
                                              "p",
                                              {
                                                class: {
                                                  tag:
                                                    column.field === "reason",
                                                  "is-danger":
                                                    column.field === "reason",
                                                  "is-light":
                                                    column.field === "reason",
                                                  "pending-row": true,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      column.field === "amount"
                                                        ? _vm.formatCurrency(
                                                            props.row[
                                                              column.field
                                                            ]
                                                          )
                                                        : props.row[
                                                            column.field
                                                          ]
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }